module.exports = __webpack_public_path__ + "static/banner-2-e7861a2c922bba0dade195f455fa6f92.png";